export function endpoint(apiUrl, path) {
  return `${apiUrl.replace(/\/$/, "")}${path.startsWith("/") ? path : `/${path}`}`;
}

export function authHeaders(accessToken) {
  return { Authorization: `Bearer ${accessToken}` };
}

export function authConfig(accessToken, config = {}) {
  return {
    ...config,
    headers: {
      ...config.headers,
      ...authHeaders(accessToken),
    },
  };
}

export function multipartAuthConfig(accessToken) {
  return authConfig(accessToken, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}
